<template>
    <div :id='layer.id' :style='[compiled_styles, custom_styles.layer]' :class="[classes.layer, {'element-has-link' : layer.config.url != ''}]" v-html='layer.config.text' @click='textClick'></div>
</template>

<script>
import format_custom_styles from "@/page_builder/builder/builder_tools/functions/format_custom_styles.js";

export default {
    props: ['layer', 'page_builder_mode'],
    mixins: [format_custom_styles],
    data(){
        return{
            compiled_styles:{},
            custom_styles: {},
            classes: []
        }
    },
    methods:{
        setStyles(){
            if(this.layer.compiled_styles != null){
                this.compiled_styles =this.layer.compiled_styles.text;
            }

            if(this.layer.compiled_classes != null){
                this.classes = this.layer.compiled_classes;
            }
        },
        textClick(){
            if(typeof this.layer.config.url !== 'undefined'){
                if(this.layer.config.url !== '' && !this.page_builder_mode){
                     if(this.layer.config.url_type != 'external'){
                        this.$router.push(this.layer.config.url);
                    }
                    else{
                        window.location.href = this.layer.config.url;
                    }
                }
            }
        },
    },
    watch:{
       'layer': {
            handler(){
                 this.setStyles();
                 this.setCustomCssStyles(this.layer.custom_styles); //From mixin
            },
            deep: true
        }
    },
    mounted(){
        this.setStyles();
        this.setCustomCssStyles(this.layer.custom_styles); 
    }

}
</script>

<style lang="scss" scoped>
.element-has-link{
    cursor: pointer;
}
</style>